import { supabase } from "../../supabaseClient";

// All billing calls go through Next.js proxy (never directly to billing server)
const API_BASE =
  process.env.REACT_APP_NEXT_API_URL || "http://localhost:3000";

export async function billingFetch(path, options = {}) {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session) throw new Error("Not authenticated");
  const res = await fetch(`${API_BASE}/api/billing${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.access_token}`,
      ...options.headers,
    },
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || `API error: ${res.status}`);
  }
  return res.json();
}

export async function billingFetchPublic(path) {
  const res = await fetch(`${API_BASE}/api/billing${path}`);
  if (!res.ok) throw new Error(`API error: ${res.status}`);
  return res.json();
}
